import { TenantBuildingState } from './types';
import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { fetchTenantBuilding } from './actions';

export const initialState: TenantBuildingState = {
  data: null,
  error: null,
  loading: false,
};

const loading = createReducer(initialState.loading)
  .handleAction(fetchTenantBuilding.request, () => true)
  .handleAction(fetchTenantBuilding.success, () => false)
  .handleAction(fetchTenantBuilding.failure, () => false);

const error = createReducer(initialState.error)
  .handleAction(fetchTenantBuilding.success, () => null)
  .handleAction(fetchTenantBuilding.failure, (_state, action) => action.payload.error);

const data = createReducer(initialState.data)
  .handleAction(fetchTenantBuilding.success, (_state, action) => action.payload.data.building)
  .handleAction(fetchTenantBuilding.failure, () => null);

export default combineReducers({ loading, error, data });
